import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { fetchProjectConfig } from '@/lib/api';

const ConfigContext = createContext(null);

export function ConfigProvider({ children }) {
  const [config, setConfig] = useState({
    proyecto_nombre: 'constructOS',
    modelos_vivienda: [],
  });

  const reload = useCallback(async () => {
    try {
      const data = await fetchProjectConfig();
      setConfig(data);
    } catch {
      // keep defaults
    }
  }, []);

  useEffect(() => { reload(); }, [reload]);

  return (
    <ConfigContext.Provider value={{ config, setConfig, reloadConfig: reload }}>
      {children}
    </ConfigContext.Provider>
  );
}

export function useConfig() {
  return useContext(ConfigContext);
}
